/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Link, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import type { ProgramSpecializationsProps } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/academics/ProgramSpecializations';

const styles: Record<string, Interpolation<Theme>> = {
  title: css`
    font-size: 18px;
  `,
  description: css`
    margin-bottom: 10px;
  `,
};

const SpecializationInfo = (specializationData: $TSFixMe) => {
  return (
    <div className="rc-SpecializationInfo">
      {specializationData.visual && (
        <Imgix className="specialization-visual" src={specializationData.visual} alt={specializationData.title} />
      )}
      <div className="specialization-info">
        <Typography2 component="h3" css={styles.title} variant="subtitleMedium">
          {specializationData.title}
        </Typography2>
        <Typography2 component="p" css={styles.description} variant="bodyPrimary">
          {specializationData.description}
        </Typography2>
        {specializationData.callToActionLink && (
          <Link href={specializationData.callToActionLink} typographyVariant="bodyPrimary" className="page-link">
            {specializationData.callToActionLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

const ProgramSpecializations = ({ specializations }: ProgramSpecializationsProps) => {
  if (!specializations || !specializations.length) {
    return null;
  }

  return <div className="rc-ProgramSpecializations rc-Section">{specializations.map(SpecializationInfo)}</div>;
};

export default ProgramSpecializations;
